import Vue from 'vue'
import Vuex from 'vuex'

import Auth from '@/store/modules/Auth'
import Bonos from '@/store/modules/Bonos'
import Clientes from '@/store/modules/Clientes'
import ClientesDistribuciones from '@/store/modules/ClientesDistribuciones'
import Creditos from '@/store/modules/Creditos'
import CreditosPleno from '@/store/modules/CreditosPleno'
import CreditosUsuario from '@/store/modules/CreditosUsuario'
import ConsumidorFinal from '@/store/modules/ConsumidorFinal'
import Cuentas from '@/store/modules/Cuentas'
import CuentasDestinos from '@/store/modules/CuentasDestinos'
import Saldos from '@/store/modules/Saldos'
import CuentasActivas from '@/store/modules/CuentasActivas'
import CuentasCerradas from '@/store/modules/CuentasCerradas'
import Debitos from '@/store/modules/Debitos'
import FormasPagos from '@/store/modules/FormasPagos'
import ImputacionesExport from '@/store/modules/ImputacionesExport'
import Parametros from '@/store/modules/Parametros'
import Precios from '@/store/modules/Precios'
import PreciosVigentes from '@/store/modules/PreciosVigentes'
import Productos from '@/store/modules/Productos'
import Sucursales from '@/store/modules/Sucursales'
import Tickets from '@/store/modules/Tickets'
import Transacciones from '@/store/modules/Transacciones'
import TransaccionesExport from '@/store/modules/TransaccionesExport'
import RecalcularSaldo from '@/store/modules/RecalcularSaldo'
import Transferencias from '@/store/modules/Transferencias'
import ReportesVentas from '@/store/modules/ReportesVentas'
import ReportesActuales from '@/store/modules/ReportesActuales'

import DiariosCreate from '@/store/modules/DiariosCreate'
import DiariosUpdate from '@/store/modules/DiariosUpdate'
import Diarios from '@/store/modules/Diarios'
import DiariosPagos from '@/store/modules/DiariosPagos'
// import DiariosVentas from '@/store/modules/DiariosVentas'
import DiariosBonos from '@/store/modules/DiariosBonos'

import ResponseHTTP from '@/store/modules/ResponseHTTP'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Auth,
    Bonos,
    Clientes,
    ClientesDistribuciones,
    Creditos,
    CreditosPleno,
    CreditosUsuario,
    Cuentas,
    CuentasDestinos,
    CuentasActivas,
    CuentasCerradas,
    ConsumidorFinal,
    Debitos,
    DiariosCreate,
    DiariosUpdate,
    Diarios,
    DiariosPagos,
    DiariosBonos,
    FormasPagos,
    ImputacionesExport,
    RecalcularSaldo,
    ReportesVentas,
    ReportesActuales,
    Parametros,
    Precios,
    PreciosVigentes,
    Productos,
    Saldos,
    Sucursales,
    Tickets,
    Transacciones,
    TransaccionesExport,
    Transferencias,
    ResponseHTTP,
  },
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
})